(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nha-home"] && !Shopify.designMode) return;
  try {
    
function initializeNhmFinders(){document.querySelectorAll('[data-nhm-finder]').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';const make=form.querySelector('[data-nhm-make]');const model=form.querySelector('[data-nhm-model]');const label=form.querySelector('.nhm-model-label');const allText=model.options[0].text;const models={Suzuki:['Alto','Cultus','Mehran','Wagon R','Swift','Bolan'],Toyota:['Corolla','Yaris','Vitz','Belta'],Honda:['Civic','City','BR-V'],Kia:['Sportage','Picanto']};label.hidden=false;make.addEventListener('change',()=>{model.replaceChildren(new Option(allText,''));(models[make.value]||[]).forEach(value=>model.add(new Option(value,value)));});form.addEventListener('submit',event=>{event.preventDefault();const url=new URL(form.action,window.location.href);url.searchParams.set('type','product');url.searchParams.set('q',[make.value,model.value].filter(Boolean).join(' '));window.location.assign(url.toString());});});}initializeNhmFinders();document.addEventListener('shopify:section:load',initializeNhmFinders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nha-signature"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nha-signature')){
customElements.define('nha-signature',class extends HTMLElement{
connectedCallback(){this.observer=new IntersectionObserver(entries=>{for(const entry of entries)this.toggleAttribute('data-visible',entry.isIntersecting)},{threshold:0});const footer=this.closest('footer');if(footer)this.observer.observe(footer)}
disconnectedCallback(){this.observer?.disconnect()}
});
}

  } catch(e) { console.error(e); }
})();
})();
